module.exports = __webpack_public_path__ + "img/map.229f0771.png";